module.exports = __webpack_public_path__ + "static/index/img/baikal-100.78c785a9.jpg";